import LineIcon from "../../assets/images/LineIcon";
import { Constants } from "../../constants/constants";
import ProfileImage2 from "../../assets/images/profile2.svg";
import Button from "../common/cta/Button";
import SearchBar from "../common/SearchBar";
import NotificationIcon2 from "../../assets/images/NotificationIcon2";
import { readFromLocalStorage } from "../../utils/DataEncryption";
import { RoleItem } from "./MobileResponsiveHeader";

const HeaderWeb = ({
  handleLogout,
  setLogout,
  isLogout,
}: {
  handleLogout: any;
  setLogout: any;
  isLogout: boolean;
}) => {
  const storedBaseRoles = readFromLocalStorage("baseRoles");
  const storedBaseRolesParsed = JSON.parse(storedBaseRoles || "[]");

  return (
    <>
      <div className="border-b-white shadow-lg">
        <div className="bg-white text-black flex items-center h-20  shadow-md px-6">
          <div>
            <div className="">
              <div className="w-[240px] text font-poppins">
                {Constants.Welcome}

                {readFromLocalStorage("userName") ?? "Dealer"}
              </div>
              <div className="text-sm font-poppins">
                {storedBaseRolesParsed.map(
                  (roleItem: RoleItem, index: number) => (
                    <div key={index}>{roleItem?.role?.name ?? "Dealer"}</div>
                  )
                )}
              </div>
            </div>
          </div>

          <div className=" w-full flex justify-end">
            <div className="mr-28">
              <SearchBar from="Header" />
            </div>
            <div className="flex  items-center">
              <div className="h-12 w-12 rounded-xl bg-sideMenubackground flex justify-center items-center">
                <NotificationIcon2 />
              </div>
              <div className="ml-6">
                <LineIcon />
              </div>
              <button
                type="button"
                onClick={() => setLogout(!isLogout)}
                className="logout-popup flex"
              >
                <div className="ml-6 mr-4">
                  <div className="w-12 h-12">
                    <img
                      height="48"
                      width="48"
                      alt="ProfileImg"
                      src={ProfileImage2}
                    />
                  </div>
                </div>
              </button>
            </div>
            {isLogout && (
              <div className=" z-10 logout-popup  flex fixed top-[90px] rounded-lg right-5 bg-white shadow-2xl w-[300px] h-[300px] ">
                <div className="p-4">
                  <Button
                    handleClick={() => {
                      handleLogout();
                    }}
                    buttonText={"Logout"}
                    className={
                      "focus:ring-4 focus:ring-gray-300 bg-primary ml-14 mt-5 text-white px-16 py-4 rounded-md transition duration-300 hover:bg-whiteColor hover:text-black hover:border-gray500 hover:border"
                    }
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderWeb;
